<template>
    <form>
        <div class="mb-3">
            <v-text-field
                v-model="user.email"
                label="Διεύθυνση email"
                :disabled="loading"
                v-bind:error-messages="allerrors.email">
            </v-text-field>
        </div>
        <div class="mb-3">
             <v-text-field
                v-model="user.password"
                type="password"
                label="Κωδικός πρόσβασης"
                :disabled="loading"
                v-bind:error-messages="allerrors.password">
            </v-text-field>
        </div>
        <button type="submit" class="btn btn-primary" :disabled="loading" @click.prevent="loginButtonClick">
            <span v-if="loading" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
            {{ loading ? 'Παρακαλώ περιμένετε...' : 'Είσοδος' }}
        </button>
    </form>
</template>

<script>
export default {
    data: () => ({
        user: {
            email: "",
            password: ""
        },
        loading: false,
        allerrors: {}
    }),

    methods: {
        loginButtonClick() {
            if (this.loading) {
                return;
            }

            this.loading = true;

            axios.post("/api/login", {
                email: this.user.email,
                password: this.user.password
            })
            .then(response => {
                if (response.data.token) {
                    localStorage.setItem('access-token', response.data.token)
                    axios.defaults.headers.common["Authorization"] = `Bearer ${response.data.token}`
                    window.location.replace("/home")
                } else {
                    this.loading = false;
                }
            })
            .catch(error => {
                this.loading = false;
                console.log('login error')
                this.$swal.fire('Σφάλμα', 'Λάθος όνομα χρήστη ή/και κωδικός πρόσβασης', 'error')
            })
        }
    }
}
</script>
